// React
import React from "react";
// Routing
// Components
import AnimakitExpander from "animakit-expander";
import OfficeSearch from "common/ui/components/officeSearch/OfficeSearch";
import ContextSelection from "app/application/ui/sideBars/ContextSelection";
// Domain
import * as userDomain from "user/user/User";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./ContextSelector.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class ContextSelector extends React.Component {
    constructor(props) {
        super(props);
        this.onExpanderClick = () => {
            if (this.props.user.userAccess.length == 1) {
                return;
            }
            this.setState({ userWantsOpen: !this.state.userWantsOpen });
        };
        this.onSelectItemClick = () => {
            this.setState({ userWantsOpen: false });
        };
        this.state = { userWantsOpen: false };
    }
    componentDidMount() {
    }
    render() {
        let { user, officeId, agencyId, menuExpanded } = this.props;
        let agencyContext = null;
        let officeContext = null;
        if (user && user.userAccess) {
            if (officeId) {
                let selectedOffice = this.props.user.userAccess.find((userAccess) => userAccess.type == userDomain.EntryType.Office &&
                    userAccess.id == officeId);
                if (selectedOffice) {
                    agencyContext = selectedOffice.agency;
                    officeContext = selectedOffice.office;
                }
            }
            if (agencyId) {
                let selectedAgency = this.props.user.userAccess.find((userAccess) => userAccess.type == userDomain.EntryType.Agency &&
                    userAccess.id == agencyId);
                if (selectedAgency) {
                    agencyContext = selectedAgency.agency;
                }
            }
        }
        // Expander state
        let isExpanded = false;
        if (!this.props.hasSelection) {
            isExpanded = true;
        }
        else if (!this.props.menuExpanded) {
            isExpanded = false;
        }
        else {
            isExpanded = this.state.userWantsOpen;
        }
        return (React.createElement("div", { className: styles.officeSearchContainer },
            React.createElement("div", { className: styles.officeSearch },
                React.createElement("div", { className: styles.officeSelection },
                    React.createElement("div", { id: "OfficeSearch", onClick: () => this.onExpanderClick() },
                        React.createElement(ContextSelection, { user: user, officeId: officeId, officeName: officeContext, agencyId: agencyId, agencyName: agencyContext, menuExpanded: menuExpanded, expanded: isExpanded })),
                    React.createElement("div", { className: styles.dropdown },
                        React.createElement(AnimakitExpander, { expanded: isExpanded, durationPerPx: 0.75, horizontal: false, align: "" },
                            React.createElement(OfficeSearch, { officeId: officeId, officeName: officeContext, agencyId: agencyId, agencyName: agencyContext, onSelectCallback: () => this.onSelectItemClick() })))))));
    }
}
